import { render, staticRenderFns } from "./PrintHeader.vue?vue&type=template&id=a8dc4a5a&scoped=true&"
import script from "./PrintHeader.vue?vue&type=script&lang=js&"
export * from "./PrintHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrintHeader.vue?vue&type=style&index=0&id=a8dc4a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dc4a5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol,VRow,VSheet,VSpacer})
